import { ExperienceSection } from "@/components/sections/experience-section";
import { PageIntroSection } from "@/components/sections/page-intro";
import { Seo } from "@/components/seo/seo";
import { useSiteContent } from "@/config/use-site-content";
import { useLocale } from "@/i18n/locale-context";
import { absoluteUrl } from "@/lib/seo-url";
import { breadcrumbJsonLd } from "@/lib/structured-data";

export function ExperiencePage(): JSX.Element {
  const { locale } = useLocale();
  const content = useSiteContent();

  return (
    <>
      <Seo
        description={content.pages.experience.description}
        jsonLd={breadcrumbJsonLd([
          { label: content.navigation[0]?.label ?? "Home", url: absoluteUrl(`/${locale}`) },
          {
            label: content.pages.experience.title,
            url: absoluteUrl(`/${locale}/experience`),
          },
        ])}
        locale={locale}
        pathWithoutLocale="/experience"
        title={content.pages.experience.title}
      />
      <PageIntroSection content={content.pages.experience} />
      <ExperienceSection items={content.experience.items} />
    </>
  );
}
